import React from 'react';
import { MenuItem } from '@mui/material';

export const CreateOptionItem = ({ label = '+ Создать', onClick }) => {
  return (
    <MenuItem value="" onClick={onClick}>
      {label}
    </MenuItem>
  );
};

export default CreateOptionItem;




